// User-facing copy: meeting. Moved from the web app (components/MeetingCard.tsx, components/MeetingQuestions.tsx, pages/club/MeetingPage.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/MeetingCard.tsx */
export const meetingCard = {
    aCaféOrA: "A café, or a call link",
    daysAgo: (x) => `${x} days ago`,
    yesterday: "yesterday",
    today: "today",
    tomorrow: "tomorrow",
    inDays: (days) => `in ${days} days`,
    noDateYet: "No date yet",
    anAdminSetsThe: "An admin sets the next meeting. The agenda builds itself meanwhile.",
    noMeetingOnThe: "No meeting on the calendar",
    anAdminSetsThe2: "An admin sets the next one here.",
    editTheMeeting: "Edit the meeting",
    edit: "Edit",
    isHosting: (name) => ` · ${name} is hosting`,
    theDateMovedFrom: (when) => `The date moved from ${when}. You said `,
    going: "going",
    canT: "can't",
    maybe: "maybe",
    yesStill: (x) => `Yes, still ${x}`,
    going2: "Going",
    canT2: "Can't",
    maybe2: "Maybe",
    going3: (going, x) => `${going} going${x}`,
    maybe3: (maybe) => ` · ${maybe} maybe`,
    thisMeetingHasPassed: "This meeting has passed.",
    isHosting2: (name) => `${name} is hosting`,
    going4: (going, x, x2) => `${going} going${x}${x2}`,
    saidYesBeforeThe: (staleYes) => ` · ${staleYes} said yes before the change`,
    openTheAgenda: "Open the agenda ›",
    nextMeeting: "Next meeting",
    whenYourLocalTime: "When (your local time)",
    pickADateAnd: "Pick a date and time.",
    whereOrACall: "Where, or a call link (optional)",
    hostOptional: "Host (optional)",
    nobodyInParticular: "Nobody in particular",
    movingTheDateAsks: "Moving the date asks everyone who said yes to confirm again. Questions stay.",
    save: "Save",
    clearTheDate: "Clear the date",
};
/** components/MeetingQuestions.tsx */
export const meetingQuestions = {
    bringAQuestion: "Bring a question…",
    open: "open",
    bringIt: "Bring it",
    whoCanSeeThis: "Who can see this",
    everyoneSeesIt: "Everyone sees it.",
    whereIAm: (herePercent) => `Where I am · ${herePercent}%`,
    sealedForAnyoneWho: "Sealed for anyone who isn't there yet.",
    landmarks: "Landmarks",
    through: (name) => `Through ${name}  `,
    sealedUntil: (posLabel, name) => ` Sealed until ${posLabel} · ${name}`,
    markNotDiscussed: "Mark not discussed",
    markDiscussed: "Mark discussed",
    save: "Save",
    cancel: "Cancel",
    you: "you",
    fromLastTime: "from last time",
    discussed: "discussed",
    more: "More",
    edit: "Edit",
    remove: "Remove",
    spoilerFree: "Spoiler-free",
};
/** pages/club/MeetingPage.tsx */
export const page = {
    planYourFirstMeeting: "Plan your first meeting",
    planAMeeting: "Plan a meeting",
    pickATimeAnd: "Pick a time and a place. The agenda fills in as the club reads.",
    noMeetingYet: "No meeting yet",
    anAdminWillSet: "An admin will set the first one. The agenda fills in as the club reads.",
    markNotDiscussed: "Mark not discussed",
    markDiscussed: "Mark discussed",
    firstReactions: "First reactions",
    stoppedAt: (percent) => ` · stopped at ${percent}%`,
    noReactionLeft: "no reaction left",
    stoppedAt2: "stopped at ",
    reply: "reply",
    replies: "replies",
    openThread: "open thread ›",
    didnTFinish: (length) => `${length} didn't finish`,
    stillReading: (length) => `${length} still reading`,
    thisMeetingCovers: (x, toPercent) => `this meeting covers ${x}${toPercent}%`,
    to: (fromPercent) => `${fromPercent}% to `,
    through: "through ",
    shelf: "Shelf",
    theMeeting: "The meeting",
    average: (average) => ` · ${average} average`,
    whereEveryoneIs: "Where everyone is",
    finished: "finished",
    stoppedAt3: (percent) => `stopped at ${percent}%`,
    readItBefore: "read it before",
    everyoneOnReading: "Everyone, on Reading",
    moreReadersOnReading: (x) => `${x} more readers, on Reading`,
    agenda: "Agenda",
    toGo: (toGo) => `${toGo} to go`,
    allDone: "all done",
    questionsWeBrought: "Questions we brought",
    fromTalk: "From Talk",
    nothingOnItYet: "Nothing on it yet. Bring a question below, or flag a message in Talk \"for the meeting\".",
    fromLastTime: (length) => `From last time · ${length}`,
    pastThisStretch: (length) => `Past this stretch · ${length}`,
    addOneOnThe: "Add one on the spot…",
    yourNotes: (x) => `Your notes · ${x}`,
    nothingYetJotOn: "Nothing yet. Jot on the Reading tab as you go.",
    openTheNotebook: "open the notebook ›",
    finishThisBookFor: "Finish this book for the club",
    movesItToThe: "Moves it to the shelf. Anyone still reading is asked whether to keep going.",
    move: "Move ",
    toFinishedNothingUnseals: " to Finished. Nothing unseals for anyone still reading; they'll be asked whether to keep going. Ticked items fold into the recap.",
    finishIt: "Finish it",
    notYet: "Not yet",
    theClubFinishedThis: "The club finished this one. See the ",
    open: "open",
    onTheAgenda: "on the agenda ›",
    takeItBack: "take it back",
    sharing: "Sharing…",
    bringItUp: "Bring it up",
    someoneHasRepliedSo: "Someone has replied, so it stays.",
    whatDidPeopleDisagree: "What did people disagree about? Best line? Would we recommend it?",
    notesFromTheMeeting: "Notes from the meeting",
    hasThePen: (name) => `${name} has the pen`,
    anyoneCanEdit: "anyone can edit",
    sealedUntilYouFinish: "Sealed until you finish the book.",
    save: "Save",
    cancel: "Cancel",
    editedBy: (name, toLocaleDateString) => `Edited by ${name} · ${toLocaleDateString}`,
    edit: "Edit",
    writeTheNote: "Write the note",
    closedAWeekAfter: "Closed a week after the meeting.",
    finished2: (length) => `${length} finished`,
};
//# sourceMappingURL=meeting.js.map